import { useContext, useMemo } from 'react';

import { DealContext } from '../libs/DealContext';
import { getSelectedOptionTypeForSelection } from '../types/products';

import { useDealPackageConfigs } from './useDealPackageConfigs';

export const useSelectedPackageOptionType = () => {
  const { deal } = useContext(DealContext);
  const { configs, queryLoading } = useDealPackageConfigs();

  const selectedOptionType = useMemo(
    () =>
      getSelectedOptionTypeForSelection({
        selectedPackageSlotIndex: deal.selected_package_slot_index,
        packageConfigs: configs,
        optionType: deal.financial_info?.option_type,
      }),
    [configs, deal.financial_info?.option_type, deal.selected_package_slot_index],
  );

  return {
    selectedOptionType,
    loading: queryLoading,
  };
};
